<template>
  <div class="new-page-con dataapiPageBox">
    <div class="layout_header">
      <Header> </Header>
    </div>
    <div class="dataapi-page dataServices-page">
      <!-- 工具栏 -->
      <ToolBar
        :ToolBarData="ToolBarData"
        @fitlers="triggerIsFitlers"
        @select="triggerIsSelect"
        @reselect="triggerIsReselect"
        @download="triggerIsDownload"
        @cart="triggerIsCart"
        :cartsTotalCount="cartsTotalCount"
      />
      <div
        class="apilistfix"
        v-if="
          ['APIHomepage_more', 'APIHomepage_more_detail'].includes(routeName)
        "
      >
        <div
          @click="apilistClick(item)"
          class="api-type"
          v-for="(item, index) in apiDataCategoryList"
          :key="index"
        >
          {{ item.categoryName }}
        </div>
      </div>

      <div
        :class="[
          'dataapi-content',
          showMargin ? 'margintopadd50' : '',
          asideWidth == '70px' ? 'asideWidth70' : '',
        ]"
      >
        <el-container>
          <el-aside :width="asideWidth" class="aside-fixed">
            <router-link :to="{ name: 'APIHomepage' }">
              <div
                :class="[
                  routeName == 'APIHomepage' ||
                  routeName == 'APIHomepage_more' ||
                  routeName == 'APIHomepage_more_detail'
                    ? 'menu-item-first-active menu-item-first'
                    : 'menu-item-first',
                ]"
              >
                <img
                  src="../../../assets/images/dataServices/dataapi-img/APIHomepage.svg"
                  alt=""
                />
                <span v-if="asideWidth == '240px'">API Homepage</span>
              </div>
            </router-link>
            <div>
              <div class="menu-item-two" v-if="asideWidth == '240px'">
                <span>API Management Center</span>
              </div>
              <div class="menu-item-two-child">
                <router-link :to="{ name: 'AccountManagement' }">
                  <div
                    :class="[
                      'menu-item-two-child-item',
                      routeName == 'AccountManagement'
                        ? 'menu-item-two-active'
                        : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName == 'AccountManagement'
                          ? require('../../../assets/images/dataServices/dataapi-img/AccountManagement-active.svg')
                          : require('../../../assets/images/dataServices/dataapi-img/AccountManagement.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">Account Management</span>
                  </div>
                </router-link>
                <router-link :to="{ name: 'Test' }">
                  <div
                    :class="[
                      'menu-item-two-child-item',
                      routeName == 'Test' ? 'menu-item-two-active' : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName == 'Test'
                          ? require('../../../assets/images/dataServices/dataapi-img/Test-active.svg')
                          : require('../../../assets/images/dataServices/dataapi-img/Test.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">Test</span>
                  </div>
                </router-link>
                <router-link :to="{ name: 'TestRecords' }">
                  <div
                    :class="[
                      'menu-item-two-child-item',
                      routeName == 'TestRecords' ? 'menu-item-two-active' : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName == 'TestRecords'
                          ? require('../../../assets/images/dataServices/dataapi-img/TestRecords-active.svg')
                          : require('../../../assets/images/dataServices/dataapi-img/TestRecords.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">Test Records</span>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="aside-status-icon">
              <img
                src="../../../assets/images/dataServices/dataapi-img/foldup-aside.svg"
                alt=""
                @click="foldupAsideClick()"
                v-if="asideWidth == '240px'"
              />
              <img
                src="../../../assets/images/dataServices/dataapi-img/expand-aside.svg"
                alt=""
                @click="expandAsideClick()"
                v-if="asideWidth == '70px'"
              />
            </div>
          </el-aside>
          <el-main class="dataapi-content-main">
            <router-view
              :key="$route.fullPath"
              :TesRecordsPageData="TesRecordsPageData"
              @fitlers="triggerIsFitlersTrue"
              @update-selection="handleSelectionChange"
              @update-drawerStatus="handleDrawerStatusChange"
              ref="childRef"
            />
          </el-main>
        </el-container>
      </div>
    </div>
    <!-- 购物车弹框 -->
    <el-drawer
      title="Bookmarks"
      :visible.sync="shoppingcartDrawer"
      size="762px"
      custom-class="carts-drawer"
    >
      <div class="demo-drawer__content">
        <div
          :class="['api-modules', item.themeCssName]"
          v-for="(item, index) in apiDataCartsList"
          :key="index"
        >
          <div class="apidrawertopbox">
            <el-checkbox
              class="api-checkbox"
              :value="item.isAllSelected"
              :indeterminate="item.isIndeterminate"
              @change="handleExternalCheckAll(index)"
            ></el-checkbox>
            <div class="apiImgBox">
              <img
                src="../../../assets/images/dataServices/dataapi-img/apiimg1.svg"
                alt=""
                class="api-img"
              />
            </div>
            <span class="api-title">{{ item.name }}</span>
          </div>
          <div class="more-table-in">
            <el-table
              :ref="'cartstable_' + index"
              class="table_box table_height_30 table_font_size_14"
              :data="item.children"
              style="width: 100%"
              empty-text="No Data"
              @selection-change="(val) => cartsSelectionChange(val, index)"
              row-key="apiPrice"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                prop="apiIdStr"
                label="API ID"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="apiName"
                label="API Name"
                align="left"
                show-overflow-tooltip
                width="200"
              >
              </el-table-column>
              <!-- <el-table-column
                prop="price"
                label="Price($)"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.price || "Free for test" }}
                </template>
              </el-table-column> -->
              <el-table-column
                prop=""
                label="Operations"
                align="center"
                width="250"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    <div
                      class="dataClean-operate"
                      @click="applyforTest(scope.row)"
                      v-if="scope.row.apiTestStatus == 1"
                    >
                      Request Access
                    </div>
                    <div class="dataClean-operate disabled" v-else>
                      Request Access
                    </div>
                    <div
                      class="dataClean-operate"
                      @click="removeCartsApi(1, scope.row)"
                    >
                      Remove
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <el-checkbox
          class="api-checkbox selectAllcheck"
          :value="isGlobalAllSelected"
          @change="isGlobalAllSelectedChange"
          :indeterminate="isGlobalIndeterminate"
          >Select All</el-checkbox
        >
        <div>
          <div class="dataClean-operate" @click="removeCartsApi(2)">
            Clear All
          </div>
          <el-button
            class="api-apply-btn"
            type="primary"
            @click.stop="applyforTestAll"
            :disabled="!ApplyforTestNum"
            >Request Access
            <span v-if="ApplyforTestNum"
              >({{ ApplyforTestNum }})</span
            ></el-button
          >
        </div>
      </div>
    </el-drawer>
    <!-- 申请测试 -->
    <ApplyForTestDialogVue
      :applyDialogVisible="applyDialogVisible"
      :applyfortestForm="applyfortestForm"
      :apiApplyforTestList="apiApplyforTestList"
      @closeApplyforTestVisible="closeApplyforTestVisible"
      @toGenerateClick="toGenerateClick"
    ></ApplyForTestDialogVue>
  </div>
</template>

<script>
import Header from "../../layout/header.vue";
import ToolBar from "../components/toolBar.vue";
import ApplyForTestDialogVue from "../components/applyForTestDialog.vue";

import {
  getApiDataCategory,
  downloadPatchCategory,
  downloadPatchApi,
  getApiDataCart,
  deleteCartItem,
  generateAppKeyInfo,
  applyAccount,
  addCartItems,
  deleteCartItemsByCatoryIds,
  deleteCartItemsByApiIds,
} from "@/api/dataServicesApi";
import { downloadFromBase64, downloadFile } from "@/utils/date";
import crypto from "@/utils/crypto";
export default {
  components: {
    Header,
    ToolBar,
    ApplyForTestDialogVue,
  },
  name: "dataApi",
  data() {
    return {
      cartsTotalCount: "",
      applyDialogVisible: false,
      applyfortestForm: {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      },
      apiApplyforTestList: [], //一级的二级api
      // 购物车数据
      ApplyforTestNum: "", //打算申请测试的所有数量
      isGlobalAllSelected: false, //所有分组内是否选中状态
      isGlobalIndeterminate: false,
      apiDataCartsList: [],
      // apiDataCartsList: [
      //   {
      //     tableData: [
      //       {
      //         apiPrice: Date.now() + Math.random(),
      //         apiName: "用户 A",
      //         apiIdStr: "a",
      //         id:1,
      //       },
      //       {
      //         apiPrice: Date.now() + Math.random(),
      //         apiName: "用户 A2",
      //         apiIdStr: "a2",
      //         id:2,
      //       },
      //     ],
      //     API: "Admin Data",
      //     // selectedCount: 0, // 当前选中数量
      //     isAllSelected: false, // 外部多选框是否全选
      //     isIndeterminate: false, // 外部多选框是否半选
      //     selectedRows: [], //存放当前组被选中的数据
      //   },
      //   {
      //     tableData: [
      //       {
      //         apiPrice: Date.now() + Math.random(),
      //         apiName: "用户 B",
      //         apiIdStr: "B",
      //         id:2,
      //       },
      //     ],
      //     API: "Admin Data",
      //     // selectedCount: 0, // 当前选中数量
      //     isAllSelected: false, // 外部多选框是否全选
      //     isIndeterminate: false, // 外部多选框是否半选
      //     selectedRows: [],
      //   },
      //   {
      //     tableData: [
      //       {
      //         apiPrice: Date.now() + Math.random(),
      //         apiName: "用户 c",
      //         apiIdStr: "c",
      //         id:2,
      //       },
      //     ],
      //     API: "Admin Data",
      //     // selectedCount: 0, // 当前选中数量
      //     isAllSelected: false, // 外部多选框是否全选
      //     isIndeterminate: false, // 外部多选框是否半选
      //     selectedRows: [],
      //   },
      // ],
      // 购物车弹框
      shoppingcartDrawer: false,

      asideWidth: "240px",
      TesRecordsPageData: {
        isOpen: false,
        isShowCheckBtn_APIH: false, //显示隐藏复选框
        isShowCheckBtn_APIH_m: false,
        isShowCheckBtn_AManagment: false,
        // isShowCheckBtn_TRecords:false,
        isReselectCheckBtn_APIH: false, //重置选中的复选框
        isReselectCheckBtn_APIH_m: false,
        isReselectCheckBtn_AManagment: false,
      },
      ToolBarData: {},

      routeName: "APIHomepage",
      apimodulesList: [
        "Admin Data",
        "Contact_Info",
        "Owenship data",
        "Related Companies",
        "Financial performance",
        "Analytics",
        "Import&Export",
        "Negative",
        "Operation data",
        "Publications",
      ],
      apiDataCategoryList: [],
      selectedApiData: [], //子组件中被选中的api数据列表
      downloadType: 0,
    };
  },
  mounted() {
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    // 获取当前路径 给菜单高亮
    this.routeName = this.$route.name;
  },
  computed: {
    showMargin() {
      return ["APIHomepage_more", "APIHomepage_more_detail"].includes(
        this.routeName
      );
    },
  },
  watch: {
    // 监听整个 $route 对象的变化（路径、query、params 等）
    $route: {
      handler(to, from) {
        this.routeName = to.name;
        if (this.routeName === "APIHomepage") {
          this.ToolBarData = {
            isCartDisabled: false,
            isSelectDisabled: false,
            isDownloadDisabled: true,
            isReselectDisabled: false,
            isCreateComponentDisabled: false,
            isCartShow: true,
          };
          this.getApiCartsData();
        } else if (this.routeName === "APIHomepage_more") {
          this.ToolBarData = {
            isCartDisabled: false,
            isSelectDisabled: false,
            isDownloadDisabled: true,
            // isReselectDisabled: false,
            isCreateCombDisabled: false,
             isCartShow: true,
          };
          this.getApiCartsData();
        } else if (this.routeName === "APIHomepage_more_detail") {
          this.ToolBarData = {
            isCartDisabled: false,
            // isDownloadDisabled: false,
            isCreateCombDisabled: false,
             isCartShow: true,
          };
          this.getApiCartsData();
        } else if (this.routeName === "AccountManagement") {
          this.ToolBarData = {
            isCartDisabled: false,
            isSelectDisabled: false,
            // isDownloadDisabled: false,
            isCreateCombDisabled: false,
            isCartShow: true,
          };
          this.getApiCartsData();
        } else if (this.routeName === "Test") {
          this.ToolBarData = {
            isCartShow: false,
          };
        } else if (this.routeName === "TestRecords") {
          this.ToolBarData = {
            isExportDisabled: false,
            isFitlersDisabled: false,
            isCreateComponentShow: false,
            isFitlersShow: true,
            isCartShow: false,
          };
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getApiDataCategoryList();
  },
  methods: {
    // 购物车中批量申请测试
    async applyforTestAll() {
      // 获取账号信息
      await generateAppKeyInfo().then((res) => {
        if (res.code == 200) {
          let generateAppKeyInfo = JSON.parse(JSON.stringify(res.data));
          // 解密密码
          generateAppKeyInfo.secretKey = crypto.decrypt(
            generateAppKeyInfo.secretKey
          );
          this.applyfortestForm = JSON.parse(
            JSON.stringify(generateAppKeyInfo)
          );
          // 1. 先获取所有被选中的子项，方便统一校验
          let allSelectedRows = this.apiDataCartsList
            .filter((item) => item.selectedRows && item.selectedRows.length > 0)
            .flatMap((item) => item.selectedRows);

          // 2. 若勾选的 API 中包含Test Disabled条目，需提示：部分API暂不支持测试申请，请取消勾选后重试。
          const hasInvalidData = allSelectedRows.some(
            (row) => row.apiTestStatus !== 1
          );
          if (hasInvalidData) {
            // 3. 如果存在不满足条件的数据，弹出提示并终止后续操作
            this.$message.warning(
              "Some APIs currently do not support testing requests. Please uncheck and try again!"
            );
            return; // 关键：直接退出函数，不执行下面的 map 和赋值操作
          }
          // 获取申请弹框需要的数据
          this.apiApplyforTestList = this.apiDataCartsList
            .filter((item) => item.selectedRows && item.selectedRows.length > 0) //  1. 筛选：只保留有选中数据的组
            .map((item) => {
              // 2. 处理选中的子数据：给 selectedRows 里的每一项添加新属性
              let processedChildren = item.selectedRows.map((child) => {
                return {
                  ...child, // 保留子项原有数据 (id, apiName 等)
                  // --- 在这里添加你需要的新属性 ---
                  days: this.applyfortestForm.days,
                  callCount: this.applyfortestForm.callCount,
                  applicationDate: this.applyfortestForm.createTime,
                };
              });

              // 3. 返回新的一级对象
              return {
                ...item, // 保留一级原有数据 (tableData, API 等)
                APIName: item.name,
                selectedChildren: processedChildren, // 将处理后的数组赋值给新属性
              };
            });
          this.apiIdArr = this.apiApplyforTestList.flatMap((group) => {
            // group 代表每一组数据（包含 selectedChildren）
            return group.selectedChildren.map((child) => child.apiIdStr);
          }); //所有二级的id
          this.applyDialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 单一申请测试
    async applyforTest(row) {
      this.applyRow = row; //当前点击申请的一级信息
      // 获取账号信息
      await generateAppKeyInfo().then((res) => {
        if (res.code == 200) {
          let generateAppKeyInfo = JSON.parse(JSON.stringify(res.data));
          // 解密密码
          generateAppKeyInfo.secretKey = crypto.decrypt(
            generateAppKeyInfo.secretKey
          );
          this.applyfortestForm = JSON.parse(
            JSON.stringify(generateAppKeyInfo)
          );
          this.getApiDataList(this.applyRow); //获取当前一级的二级api
          this.applyDialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关闭申请测试弹框
    closeApplyforTestVisible() {
      this.applyDialogVisible = false;
      this.applyfortestForm = {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      };
      this.apiIdArr = []; //二级id置空防止单一申请和批量申请时冲突
    },
    // 获取所有二级分类 用于申请弹框显示 和 生成接口的参数
    async getApiDataList(row) {
      let applyArr = [
        {
          APIName: row.categoryApiName,
          selectedChildren: JSON.parse(JSON.stringify([row])),
          // 给每个模块添加主题色(随机的)
          themeCssName: ["yellowTheme", "purpleTheme", "blueTheme"][
            (row.categoryApiId - 1) % 3
          ],
        },
      ];
      //遍历 selectedChildren 数组，为每一项添加新属性
      applyArr[0].selectedChildren.forEach((item) => {
        item.days = this.applyfortestForm.days;
        item.callCount = this.applyfortestForm.callCount;
        item.applicationDate = this.applyfortestForm.createTime;
      });
      this.apiApplyforTestList = JSON.parse(JSON.stringify(applyArr));
      this.apiIdArr = [row.apiIdStr]; //所有二级的id
    },
    // 生成
    async toGenerateClick() {
      try {
        let params2 = {
          appKey: this.applyfortestForm.appKey,
          apiId: this.apiIdArr, //二级的分类id
          env: 1, //1是测试2是生产
        };
        let res2 = await applyAccount(params2);
        if (res2.code == 200) {
          if (res2.data.failApisNoRepeat && res2.data.failApisNoRepeat.length) {
            // 有重复的账号被申请
            this.$message.warning(
              "Some APIs have already been applied. Only unapplied APIs will be processed in batch."
            );
          } else {
            this.$message.success(res2.msg);
          }
          // 跳转到账号管理页面
          this.$router.push({ name: "AccountManagement" });
          this.shoppingcartDrawer = false; //购物车弹框关闭
        } else {
          this.$message.error(res2.msg);
        }
        this.closeApplyforTestVisible();
      } catch (error) {
        // console.log("error", error);
      }
    },
    // 购物车逻辑--op
    // 1.购物车内弹框的复选框逻辑--op
    // 点击工具栏上的购物车按钮显示购物车弹框
    async triggerIsCart() {
      // 购物车查询一下
      this.getApiCartsData(true); //true展开购物车所有复选框默认选中
      this.shoppingcartDrawer = true; //显示弹框
    },
    // 外部多选框点击事件（切换选择一级api）
    handleExternalCheckAll(index) {
      // 1. 根据 index 找到对应的表格 ref
      // 注意：ref 在 v-for 中会变成数组，所以我们要取 [0]
      const tableRef = this.$refs["cartstable_" + index][0];

      // 2. 判断当前表格是否已经全选
      const currentSelection = tableRef.selection;
      const totalCount = this.apiDataCartsList[index].children.length;
      const isTableAllSelected = currentSelection.length === totalCount;

      // 3. 根据用户意图操作表格 isAllSelected为false 不是全选状态 想要去全选
      if (!this.apiDataCartsList[index].isAllSelected) {
        // 用户勾选了外部框（意图：全选）
        if (!isTableAllSelected) {
          tableRef.toggleAllSelection();
        }
      } else {
        // 用户取消了外部框（意图：取消全选）
        if (isTableAllSelected) {
          tableRef.toggleAllSelection(); // 如果是全选状态，点击切换为不选
        } else {
          tableRef.clearSelection(); // 如果是半选状态，直接清空
        }
      }
    },
    // --- 监听表格变化 (增加全局状态计算) 表格中多选框触发事件(切换选择二级api)---
    cartsSelectionChange(val, index) {
      const group = this.apiDataCartsList[index];
      const totalCount = group.children.length;

      // 1. 更新当前分组数据
      group.selectedRows = val;
      // console.log("val--当前分组被选中的数据", val);

      // 2. 更新当前分组状态
      if (val.length === 0) {
        group.isAllSelected = false;
        group.isIndeterminate = false;
      } else if (val.length === totalCount) {
        group.isAllSelected = true;
        group.isIndeterminate = false;
      } else {
        group.isAllSelected = false;
        group.isIndeterminate = true;
      }

      // 3. 【核心新增】计算全局状态
      this.updateGlobalStatus();
    },
    // 【核心新增】计算全局是否全选
    updateGlobalStatus() {
      const totalRows = this.apiDataCartsList.reduce(
        (sum, group) => sum + group.children.length,
        0
      );
      // 所有分组表格中被选中的数量
      const selectedRows = this.apiDataCartsList.reduce(
        (sum, group) => sum + group.selectedRows.length,
        0
      );
      this.ApplyforTestNum = selectedRows; //计数被选中的数量
      if (selectedRows === 0) {
        this.isGlobalAllSelected = false;
        this.isGlobalIndeterminate = false;
      } else if (selectedRows === totalRows) {
        this.isGlobalAllSelected = true;
        this.isGlobalIndeterminate = false;
      } else {
        this.isGlobalAllSelected = false;
        this.isGlobalIndeterminate = true;
      }
    },
    // 切换选择所有分组的一级api和二级api的多选框事件 即全选
    isGlobalAllSelectedChange(checked) {
      // 1. 遍历所有分组
      this.apiDataCartsList.forEach((item, index) => {
        const tableRef = this.$refs["cartstable_" + index][0];

        // 2. 根据 checked 状态强制设置表格选中项
        if (checked) {
          // 全选：将选中行设为表格的所有数据
          item.children.forEach((row) => {
            tableRef.toggleRowSelection(row, true);
          });
        } else {
          // 取消全选：清空
          tableRef.clearSelection();
        }

        // 3. 同步当前分组的状态变量（因为直接改了 selection，不会触发 @selection-change，需手动同步）
        item.selectedRows = checked ? [...item.children] : [];
        item.isAllSelected = checked;
        item.isIndeterminate = false;
      });

      // 4. 更新全局状态
      this.isGlobalAllSelected = checked;
      this.isGlobalIndeterminate = false;
    },

    // 1.购物车内弹框的复选框逻辑--end
    // 接收子组件中点击购物车按钮事件传的值
    handleDrawerStatusChange(isShowVal, data, isAddStatus, apiType) {
      this.addCartList =
        data && data.length > 0 ? JSON.parse(JSON.stringify(data)) : [];
      console.log(
        "添加到购物车的数据this.addCartList",
        this.addCartList,
        isShowVal,
        data,
        isAddStatus,
        apiType
      );
      if (isAddStatus == 1) {
        // 1 说明是加入过购物车的 点击则取消加入购物车
        this.clearAddCartClick(apiType);
      } else {
        // 0 说明未加入购物车 点击则加入购物车
        this.addCartClick(isShowVal, apiType);
      }
    },

    // 2.购物车查询
    async getApiCartsData(needSelectAll = false) {
      // let params={
      //   cartEnv:1,//1测试
      // }
      getApiDataCart().then((res) => {
        if (res.code == 200) {
          this.apiDataCartsList = JSON.parse(JSON.stringify(res.data));
          if (this.apiDataCartsList && this.apiDataCartsList.length > 0) {
            this.apiDataCartsList.forEach((item, index) => {
              item.isAllSelected = false; // 外部多选框是否全选
              item.isIndeterminate = false; // 外部多选框是否半选
              item.selectedRows = []; //存放当前组被选中的数据
              item.themeCssName = ["yellowTheme", "purpleTheme", "blueTheme"][
                index % 3
              ];
            });
            // 标记为需要全选，等待 DOM 更新后执行
            console.log("needSelectAll------", needSelectAll);
            // needSelectAll true 说明此时购物车弹框显示 弹框内复选框要全选 也就是说 needSelectAll值和是否显示购物车弹框值其实是一样
            if (needSelectAll) {
              this.$nextTick(() => {
                // 调用全选逻辑
                this.isGlobalAllSelectedChange(true);
              });
            }
            this.cartsTotalCount = this.apiDataCartsList.flatMap(
              (item) => item.children || []
            ).length; // 提取所有 children 并拍平
          } else {
            this.cartsTotalCount ='';
            this.ApplyforTestNum=''
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            customClass: "messageIndex3000", //设置层级，必须大于 el-drawer 的默认层级 (2000)
          });
        }
      });
    },
    // 3.购物车删除
    removeCartsApi(type, row) {
      let params;
      if (type == 1) {
        // 单个删除
        params = [row.cartItemId];
      } else {
        // 全部删除
        params = this.apiDataCartsList.flatMap((item) => {
          // 1. 获取当前组的 children
          const rows = item.children || [];
          // 2. 提取 id
          return rows.map((row) => row.cartItemId);
        });
      }
      deleteCartItem(params).then((res) => {
        if (res.code == 200) {
          if (type == 2) {
            this.$message.success("Empty shopping cart.");
          } else {
            this.$message.success(res.msg);
          }
          // 购物车内单个删除成功后 复选框还得重新默认全选
          this.getApiCartsData(true);
          // 重新获取页面数据 为了更新五角星是否高亮
          // 通过 this.$refs 访问子组件实例并调用方法
          if (this.routeName == "APIHomepage") {
            this.$refs.childRef.getApiDataCategoryList();
          } else if (this.routeName == "APIHomepage_more") {
            this.$refs.childRef.getApiDataApiPageList();
          } else if (this.routeName == "APIHomepage_more_detail") {
            this.$refs.childRef.getApiDataApiItemByIdList();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 4.添加到购物车
    addCartClick(isShowVal, apiType) {
      // 如果有添加数据
      if (this.addCartList && this.addCartList.length > 0) {
        addCartItems(this.addCartList).then((res) => {
          if (res.code == 200) {
            if (
              res.data.failedApiDataCarts &&
              res.data.failedApiDataCarts.length
            ) {
              // 有重复的api被添加到购物车
              this.$message({
                message:
                  "Some APIs have already been applied. Only unapplied APIs will be processed in batch.",
                type: "warning",
                customClass: "messageIndex3000", //设置层级，必须大于 el-drawer 的默认层级 (2000)
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
                customClass: "messageIndex3000", //设置层级，必须大于 el-drawer 的默认层级 (2000)
              });
            }
            this.getApiCartsData(isShowVal);
            this.shoppingcartDrawer = isShowVal; //是否显示弹框
            // 以下代码主要是 在一级页面和二级页面 二级详情页面 点击星星图标 加入购物车成功后 页面需要重新调一下获取页面数据方法这样星星的状态才会改变
            if (apiType == 1) {
              // 通过 this.$refs 访问子组件实例并调用方法
              this.$refs.childRef.getApiDataCategoryList();
            } else if (apiType == 2) {
              // 通过 this.$refs 访问子组件实例并调用方法
              if (this.routeName == "APIHomepage_more") {
                this.$refs.childRef.getApiDataApiPageList();
              } else if (this.routeName == "APIHomepage_more_detail") {
                this.$refs.childRef.getApiDataApiItemByIdList();
              }
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              customClass: "messageIndex3000", //设置层级，必须大于 el-drawer 的默认层级 (2000)
            });
          }
        });
      } else {
        // 购物车查询一下
        this.getApiCartsData(isShowVal);
        this.shoppingcartDrawer = isShowVal; //显示弹框
      }
    },
    // 5.五角星按钮的取消加入购物车 单一的
    clearAddCartClick(apiType) {
      if (apiType == 1) {
        // 一级页面中只要传一级id 就好
        let params = [this.addCartList[0].categoryApiId];
        // this.addCartList.forEach(item=>{
        //   params.push(item.categoryApiId)
        // })
        // 删除一级id下的购物信息
        deleteCartItemsByCatoryIds(params).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.getApiCartsData();
            // 通过 this.$refs 访问子组件实例并调用方法
            this.$refs.childRef.getApiDataCategoryList();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        // 删除二级id下的购物信息
        let params = [];
        this.addCartList.forEach((item) => {
          params.push(item.apiId);
        });
        deleteCartItemsByApiIds(params).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.getApiCartsData();
            // 通过 this.$refs 访问子组件实例并调用方法
            if (this.routeName == "APIHomepage_more") {
              this.$refs.childRef.getApiDataApiPageList();
            } else if (this.routeName == "APIHomepage_more_detail") {
              this.$refs.childRef.getApiDataApiItemByIdList();
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    
    // 购物车逻辑--end
    foldupAsideClick() {
      this.asideWidth = "70px";
    },
    expandAsideClick() {
      this.asideWidth = "240px";
    },
    // Fitlers工具不可点击
    triggerIsFitlers() {
      this.TesRecordsPageData.isOpen = true;
      this.ToolBarData.isFitlersDisabled = true;
    },
    // Fitlers工具可点击
    triggerIsFitlersTrue() {
      this.TesRecordsPageData.isOpen = false;
      this.ToolBarData.isFitlersDisabled = false;
    },
    // 点击select工具页面的复选框才会显示
    triggerIsSelect() {
      if (this.routeName === "APIHomepage") {
        this.TesRecordsPageData.isShowCheckBtn_APIH =
          !this.TesRecordsPageData.isShowCheckBtn_APIH;
      } else if (this.routeName === "APIHomepage_more") {
        this.TesRecordsPageData.isShowCheckBtn_APIH_m =
          !this.TesRecordsPageData.isShowCheckBtn_APIH_m;
      } else if (this.routeName === "AccountManagement") {
        this.TesRecordsPageData.isShowCheckBtn_AManagment =
          !this.TesRecordsPageData.isShowCheckBtn_AManagment;
      }
    },
    // 取消所有选中的复选框
    triggerIsReselect() {
      if (this.routeName === "APIHomepage") {
        this.TesRecordsPageData.isReselectCheckBtn_APIH = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_APIH = false;
          }, 100);
        });
      } else if (this.routeName === "APIHomepage_more") {
        this.TesRecordsPageData.isReselectCheckBtn_APIH_m = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_APIH_m = false;
          }, 100);
        });
      } else if (this.routeName === "AccountManagement") {
        this.TesRecordsPageData.isReselectCheckBtn_AManagment = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_AManagment = false;
          }, 100);
        });
      }
    },
    // 接收子组件传来的数据
    handleSelectionChange(data, type) {
      // type 1代表一级api当前在APIHomepage页面 2代表二级api当前在APIHomepage_more页面
      this.selectedApiData = data;
      console.log(
        "父组件收到子组件传过来的选中复选框的api数据的id",
        this.selectedApiData,
        type
      );
      if (!this.selectedApiData.length) {
        // 没有选api列表
        this.ToolBarData.isDownloadDisabled = true;
      } else {
        this.ToolBarData.isDownloadDisabled = false;
      }
      this.downloadType = type;
    },
    // 点击下载api接口文档zip
    async triggerIsDownload() {
      if (this.downloadType == 1) {
        let params = {
          categoryIds: this.selectedApiData,
        };
        downloadPatchCategory(params).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "api.zip";
            link.click();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (this.downloadType == 2) {
        let params = {
          apiIds: this.selectedApiData,
        };
        downloadPatchApi(params).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "api.zip";
            link.click();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 获取api列表
    getApiDataCategoryList() {
      //根据分类名称获取标签精准查询的参数
      let params = {
        // categoryName:"测试",
        // labelIds:[1,2]
      };
      getApiDataCategory(params).then((res) => {
        if (res.code == 200) {
          this.apiDataCategoryList = JSON.parse(JSON.stringify(res.data));
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 当页面在APIHomepage_more和APIHomepage_more_detail中 点击切换不同类型的more列表
    apilistClick(row) {
      this.$router.push({
        name: "APIHomepage_more",
        query: { id: row.id, categoryName: row.categoryName },
      });
    },
  },
};
</script>
<style>
.messageIndex3000.el-message {
  z-index: 3000 !important;
}
</style>
<style scoped>
/* 购物车弹框 */
.dataapiPageBox
  .carts-drawer
  .more-table-in
  .table_box
  /deep/
  .el-table__header-wrapper
  .el-checkbox {
  visibility: hidden;
}
.dataapiPageBox /deep/ .carts-drawer .el-drawer__header {
  display: flex !important;
  border-bottom: 1px solid #d9d9d9;
  font-size: 18px;
  color: #141414;
  padding-bottom: 20px;
  margin-bottom: 12px;
}
.dataapiPageBox /deep/ .carts-drawer .demo-drawer__content {
  margin-bottom: 120px;
}
.carts-drawer .demo-drawer__footer {
  padding: 10px 30px 10px 30px;
  border-top: 1px solid #d9d9d9;
  text-align: right;
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: #fff;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.carts-drawer .demo-drawer__footer .selectAllcheck /deep/ .el-checkbox__label {
  font-size: 16px;
  color: #b98b73;
  cursor: pointer;
}
.carts-drawer .api-modules {
  padding: 0 24px 0 32px;
  margin-bottom: 20px;
}
.carts-drawer .apidrawertopbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.carts-drawer .apidrawertopbox .apiImgBox {
  /* width: 58px; */
  flex: 0 0 29px; /* 不增长、不收缩、基础宽度 300px */
  height: 29px;
  border-radius: 4px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
  margin: 0 15px;
}
.carts-drawer .apidrawertopbox .apiImgBox img {
  width: 20px;
}
.carts-drawer .api-modules.yellowTheme .apiImgBox {
  background: #ffbc7d !important;
}
.carts-drawer .api-modules.purpleTheme .apidrawertopbox .apiImgBox {
  background: #c2c5f8 !important;
}
.carts-drawer .api-modules.blueTheme .apidrawertopbox .apiImgBox {
  background: #b5d1f7 !important;
}
.carts-drawer .apidrawertopbox .api-title {
  font-size: 18px;
  color: #1a2332;
}
.carts-drawer .more-table-in /deep/ .el-table__empty-text {
  padding: 85px 0;
}
.carts-drawer .more-table-in /deep/ th.el-table__cell {
  background: #f3f3f3;
}
.carts-drawer .more-table-in /deep/ td.el-table__cell {
  height: auto;
  padding: 18px 0;
}
.carts-drawer .more-table-in /deep/ th.el-table__cell {
  padding: 13px 0;
}
.carts-drawer .more-table-in /deep/ .cell {
  font-size: 16px !important;
}
.carts-drawer .more-table-in /deep/ .el-table__expand-icon {
  display: block !important;
}
.carts-drawer
  .more-table-in
  /deep/
  .el-table__expand-icon
  .el-icon-arrow-right {
  left: 50%;
  top: 50%;
  margin: 0;
  right: auto;
  transform: translate(-50%, -50%) rotate(90deg);
}
.carts-drawer
  .more-table-in
  /deep/
  .el-table__expand-icon.el-table__expand-icon--expanded
  .el-icon-arrow-right {
  transform: translate(-50%, -50%) rotate(180deg);
}
.carts-drawer .more-table-in /deep/ .el-table__expanded-cell {
  background: #f0f0f0 !important;
  padding: 14px !important;
}
.carts-drawer .more-table-in /deep/ .el-table__expanded-cell:hover {
  background: #f0f0f0 !important;
}
.carts-drawer .more-table-in /deep/ .expanded td.el-table__cell {
  border-bottom: 0 !important;
}
.carts-drawer .more-table-in /deep/ .tree_table_box {
  padding: 0 !important;
}
.carts-drawer .more-table-in .dataClean-operate {
  font-size: 16px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 15px;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
}
.carts-drawer .more-table-in .dataClean-operate:not(:last-child) {
  border-right: 1px solid #d3d3d3;
}
.carts-drawer .more-table-in .dataClean-operate:first-of-type {
  padding-left: 0;
}
.carts-drawer .more-table-in .dataClean-operate:last-of-type {
  padding-right: 0;
}
.carts-drawer .more-table-in .dataClean-operate.disabled {
  color: #dfcec5;
  cursor: not-allowed;
}
.carts-drawer .demo-drawer__footer .dataClean-operate {
  font-size: 16px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 15px;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
}
/* 购物车弹框 end */

.dataapi-page {
  overflow: auto;
}
.dataapi-content {
  margin: 76px 20px 20px 20px;
}
.dataapi-content.margintopadd50 {
  margin: 80px 20px 20px 20px;
}
.dataapi-content.margintopadd50 .el-container .el-aside {
  top: 218px;
  height: calc(100vh - 250px);
}
.dataapi-content .el-container .el-aside {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 14px;
  position: fixed;
  top: 165px;
  left: 20px;
  height: calc(100vh - 194px);
  min-height: 350px;
  /* width: 240px !important; 覆盖 el-aside 默认样式 */
  z-index: 100;
  background-color: #fff;
  border-right: 1px solid #ebeef5;
  overflow-y: auto; /* 如果菜单项太多，允许菜单自身滚动 */
}

.menu-item-first {
  width: 100%;
  height: 48px;
  line-height: 48px;
  padding: 0 14px;
  font-size: 18px;
  color: #1a2332;
  border: 1px solid #b98b73;
  border-radius: 8px;
  margin-bottom: 28px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0 10px;
}
.asideWidth70 .menu-item-first {
  justify-content: center;
}
.menu-item-first img {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  margin-right: 10px;
}
.menu-item-first-active {
  background: linear-gradient(180deg, #ecab89 0%, #ffffff 62%);
}
.menu-item-two {
  font-size: 16px;
  color: #999999;
  margin-bottom: 14px;
}
.menu-item-two-child {
  font-size: 16px;
}
.menu-item-two-child .menu-item-two-child-item {
  margin-bottom: 8px;
  color: #666666;
  padding: 9px 12px;
  background: transparent;
  border-radius: 8px;
}
.menu-item-two-child .menu-item-two-child-item img {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin-right: 13px;
}
.menu-item-two-child .menu-item-two-child-item.menu-item-two-active {
  color: #1a2332;
  background: #f2f3f7;
}
.dataapi-content-main {
  margin: 0 20px 0px 260px;
  padding: 0;
  /* min-height: 100vh;  */
}
/* 展开收起 */
.aside-status-icon {
  border-top: 1px solid #cccccc;
  position: absolute;
  bottom: 10px;
  width: 200px;
  padding: 20px 0 10px 0;
  cursor: pointer;
}
.asideWidth70 .dataapi-content-main {
  margin-left: 90px;
}
.asideWidth70 .aside-status-icon {
  width: 30px;
}
.asideWidth70 .menu-item-first {
  padding: 0 6px;
  margin-bottom: 14px;
}
.asideWidth70 .menu-item-first img {
  margin-right: 0px;
}
.dataapi-content.asideWidth70 .el-container .el-aside {
  padding: 20px 10px;
}
/* 整个滚动条 */
.dataapi-content-main::-webkit-scrollbar {
  width: 2px !important; /* 垂直滚动条宽度 */
  height: 2px !important; /* 水平滚动条高度 */
}
.apilistfix {
  height: 50px;
  background: #b98b73;
  display: flex;
  justify-content: center;
  gap: 1rem;
  position: sticky;
  top: 56px;
  z-index: 101;
  align-items: center;
}
.apilistfix .api-type {
  padding: 5px 10px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  /* 字体 内容改成16px 包括按钮里字体*/
  /* 圆角 改成10px */
  /* padding *0.75 */
  /* margin *0.75 */
  /* 表格 表头高度 44px 内容高度50px */
  .dataapi-content {
    margin-top: 60px;
  }
  .dataapi-content .el-container .el-aside {
    top: 118px;
    height: calc(100vh - 138px);
  }
  .dataapi-content.margintopadd50 {
    margin-top: 60px;
  }
  .dataapi-content.margintopadd50 .el-container .el-aside {
    height: calc(100vh - 188px);
    top: 168px;
  }
  .apilistfix {
    top: 40px;
  }
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  /* 字体 内容改成14px 包括按钮里字体*/
  /* 圆角 改成8px */
  /* padding *0.67 */
  /* margin *0.67 */
  /* 表格 表头高度 40px 内容高度44px*/
  .dataapi-content {
    margin-top: 60px;
  }
  .dataapi-content .el-container .el-aside {
    height: calc(100vh - 138px);
    top: 118px;
    left: 20px;
  }
  .dataapi-content.margintopadd50 {
    margin-top: 60px;
  }
  .dataapi-content.margintopadd50 .el-container .el-aside {
    height: calc(100vh - 188px);
    top: 168px;
    left: 20px;
  }
  .apilistfix {
    top: 40px;
  }
}
</style>
